var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardShell',{attrs:{"api":_vm.api,"lang":_vm.language}})
}
var staticRenderFns = []

export { render, staticRenderFns }